import { useState, useEffect } from "react";
import "./style.scss";
import { ArrowLeftIcon, ArrowRightIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import { useWeddingBanner } from "hooks/api/useWedding";
import Skeleton from "components/BaseWidgets/skeleton";
import { displayTextOrDash } from "utils/formatHelper";

function WeddingStoreBannerCard({
  showIndicators = true,
  showArrows = true,
  autoSlide = true,
  slideInterval = 5000,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // banner api
  const { data: bannerData, isLoading: isBannerLoading } = useWeddingBanner();

  const totalImages = bannerData?.length;
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? totalImages - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentIndex((prev) => (prev === totalImages - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (!autoSlide || totalImages <= 1) return;
    const intervalId = setInterval(handleNext, slideInterval);
    return () => clearInterval(intervalId);
  }, [autoSlide, slideInterval, totalImages]);

  if (isBannerLoading) return <Skeleton label={false} height={400} />;
  if (bannerData.length === 0 || !bannerData) return;

  return (
    <div className="wedding-banner-card">
      {bannerData.map((banner, index) => (
        <div
          key={index}
          className={`wedding-banner-layer ${index === currentIndex ? "active" : ""}`}
        >
          <img
            className="wedding-banner-image"
            src={banner?.image}
            alt={`wedding-store-banner-${index}`}
          />
          <div className="wedding-banner-overlay">
            <div className="wedding-banner-text">
              {banner.title && (
                <p className="exclusive-label">
                  {displayTextOrDash(banner?.title)}
                </p>
              )}
              <div className="headline-description-group">
                {banner.title && (
                  <h1 className="headline">
                    {displayTextOrDash(banner.title)}
                  </h1>
                )}
                {banner?.description && (
                  <p className="description">
                    {displayTextOrDash(banner?.description)}
                  </p>
                )}
              </div>
            </div>

            <div className="carousel-controls">
              {showIndicators && bannerData.length > 1 && (
                <div className="carousel-indicator">
                  {bannerData.map((_, i) => (
                    <span
                      key={i}
                      className={`dot ${i === currentIndex ? "active" : ""}`}
                      onClick={() => setCurrentIndex(i)}
                    />
                  ))}
                </div>
              )}
              {showArrows && bannerData.length > 1 && (
                <div className="arrows">
                  <Button
                    variant="round"
                    className="arrow-left"
                    onClick={handlePrev}
                  >
                    <ArrowLeftIcon />
                  </Button>
                  <Button
                    variant="round"
                    className="arrow-right"
                    onClick={handleNext}
                  >
                    <ArrowRightIcon />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default WeddingStoreBannerCard;
